module.exports = __webpack_public_path__ + "static/kasian-logo-5ab41c50f5b0cec3c56e85dfe36ffc0b.png";